import { faCircleCheck, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import './UniModalUserNew.scss';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { useUserStore } from "../../store/user";
import { CustomerResponse, UsersResponse, createUser, getAllCustomers } from "../../services/userService";
import UniInput from "../UniInput/UniInput";
import UniModal from "../UniModal/UniModal";
import { useTranslation } from 'react-i18next';

const UniModalUserNew = (props: any) => {
    const [selectedUser, setSelecteUser] = useState<any>({});
    const [showForm, setShowForm] = useState(false);
    const [showError, setShowError] = useState(false);
    const [showModalSuccess, setShowModalSuccess] = useState(false);
    const [showModalError, setShowModalError] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [errorName, setErrorName] = useState<string>('');
    const [errorEmail, setErrorEmail] = useState<string>('');
    const [errorProfile, setErrorProfile] = useState<string>('');
    const [users, setUsers] = useState<UsersResponse[]>();
    const [customers, setCustomers] = useState<any[]>();
    const [userEmail, setUserEmail] = useState<string>('');
    const [userName, setUserName] = useState<string>('');
    const [userActive, setUserActive] = useState(true);
    const [selectedCustomers, setSelectedCustomers] = useState<any>();
    const [selectedProfile, setSelectedProfile] = useState<any>();
    const [selectedActive, setSelectedActive] = useState<boolean>(false);
    const [loading, setLoading] = useState(false);
    const { darkMode, selectedCustomer } = useUserStore();
    const { i18n, t } = useTranslation();

    const mockDataTable = {
        headers: [
            {
                property: 'name',
                name: t('user.labelName'),
            },
            {
                property: 'email',
                name: 'Email',
            },
            {
                property: 'active',
                name:  t('user.labelActive')
            },
            {
                property: 'createdAt',
                name:  t('user.labelCreatedAt'),
                date: true
            },
            {
                property: 'profile',
                name:  t('user.labelProfile'),
                enum: true
            },
            {
                property: 'actions',
                name:  t('user.labelActions')
            },
        ]
    };

    const hide = () => {
        //setShowModalSuccess(false);
        setErrorName('');
        setErrorEmail('');
        setErrorProfile('');
        setUserName('');
        setUserEmail('');
        setSelectedProfile(0);
        setSelectedCustomers([]);
        setShowForm(false);
        props.onHide();
    }

    useEffect(() => {
        if (props.show && !showForm) {
            setLoading(true);
            setShowForm(true);
            getAllCustomers()
                .then(data => {
                    setCustomers(data.data?.customers.map(c => { return { value: c.id, label: `${c.issuer} ${c.searchTerm1 ? c.searchTerm1 : c.searchTerm2 ? c.searchTerm1 : c.issuerName}`, ...c } }));
                })
                .catch(err => console.log(err))
                .finally(() => setLoading(false))
        }
    }, [props.show]);

    const onValidation = (): Boolean => {
        let isValid = true;
        if (userName == '') {
            setErrorName(t('user.validateName'));
            isValid = false;
        } else {
            setErrorName('');
        }
        if (userEmail == '') {
            setErrorEmail(t('user.validateEmail'));
            isValid = false;
        } else {
            setErrorEmail('');
        }
        console.log(selectedProfile, 'selectedProfile');
        if (selectedProfile == '') {
            setErrorProfile(t('user.validateProfile'));
            isValid = false;
        } else {
            setErrorProfile('');
        }

        return isValid;
    }

    const create = async (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        const isValid = onValidation();
        if (isValid) {

            console.log(selectedCustomers, 'selectedCustomers');
            const customersBody: CustomerResponse[] = selectedCustomers?.map((c: any) => {
                let customer = customers?.filter(cs => cs.id == c.value)?.[0];

                if (customer) {
                    return {
                        customerId: customer.id,
                        issuer: customer.issuer,
                        customerName: customer.issuerName,
                        cpfCnpj: customer.cnpjCpf,
                        userId: selectedUser.userId
                    }
                }
            });

            setLoading(true);
            let customerids = customersBody.map(c => c.customerId);
            const response = await createUser(userName, userEmail, Number(selectedProfile), customerids);
            setLoading(false);

            if (!!response.success) {
                setShowModalSuccess(true);
                hide();
            }
            else {
                setErrorMessage(response.error ? response.error : t('user.errorSave'));
                setShowModalError(true);
            }
        }
    }

    const selectProfileOptions = [
        // { value: '4', label: 'Admin' },
        { value: '3', label: t('user.labelOperator') },
        // { value: '2', label: 'Operador Log.' },
        { value: '1', label: t('user.labelViewer') }
    ]

    return (
        <>
            <Modal
                show={props.show}
                onHide={() => hide()}
                className={showForm ? 'modal-user modal-form-user' : 'modal-user'}
                contentClassName={darkMode ? 'dark-modal-content' : ''}
            >
                <Modal.Header closeButton>
                    <div className='header-body'>
                        <Modal.Title className='mt-3'>
                            {showForm ? t('user.labelCreateUser') : t('user.labelUsers')}
                        </Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {
                        <Form onSubmit={create} className='form-user'>
                            <div className='d-flex flex-column align-items-center justify-content-between form-user-content'>
                                <div className='profile-inputs'>
                                    <label className='label'>{t('user.labelName')}</label>
                                    <div style={{ width: '80%' }}>
                                        <UniInput id='name' type='text' value={userName} onChangeInput={(e) => setUserName(e?.target?.value ?? '')} />
                                    </div>
                                    {errorName && (<p className='p-error'>{t('user.validateName')}</p>)}
                                    <label className='label'>Email</label>
                                    <div style={{ width: '80%' }}>
                                        <UniInput id='email' type='text' value={userEmail} onChangeInput={(e) => setUserEmail(e?.target?.value ?? '')} />
                                    </div>
                                    {errorEmail && (<p className='p-error'>{t('user.validateEmail')}</p>)}
                                </div>
                                <div className='d-flex justify-content-between w-100'>
                                    <div className='profile-inputs'>
                                        <label className='label'>{t('user.labelProfile')}</label>
                                        <div>
                                            <Select
                                                placeholder={t('user.labelSelect')}
                                                onChange={(value) => setSelectedProfile(value?.value)}
                                                options={selectProfileOptions}
                                                className='select-customers'
                                            />
                                        </div>
                                        {errorProfile && (<p className='p-error'>{t('user.validateProfile')}</p>)}
                                    </div>
                                    <div className='customer-input'>
                                        <label className='label'>{t('user.labelClient')}</label>
                                        {
                                            loading ? (<Spinner style={{ color: '#027948', width: 25, height: 25 }} />) : (
                                                <Select
                                                    placeholder={t('user.labelSelect')}
                                                    onChange={(newValue) => setSelectedCustomers(newValue)}
                                                    defaultValue={selectedCustomers}
                                                    options={customers}
                                                    isMulti
                                                    closeMenuOnSelect={false}
                                                    className='select-customers'
                                                />
                                            )
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className='buttons-user-form d-flex'>
                                <Button
                                    variant='outline'
                                    disabled={loading}
                                    onClick={() => {
                                        hide();
                                    }
                                    }>
                                    {t('user.labelBack')}
                                </Button>
                                <Button type='submit' disabled={loading}>{loading ? <Spinner style={{ width: 20, height: 20 }} /> : t('user.labelSave')}</Button>
                            </div>
                        </Form>
                    }
                </Modal.Body>
            </Modal>
            <UniModal
                icon={faCircleCheck}
                title={t('user.createdUserSucess')}
                message={t('user.msgUserSucess')}
                show={showModalSuccess}
                onHide={() => {
                    setShowModalSuccess(false);
                }}
                isFontAwsome
                iconWidth={100}
                iconHeight={110}
            >
                <div className='modal-body-resume'>
                    <p></p>
                    <Button onClick={() => setShowModalSuccess(false)}>Ok!</Button>
                </div>
            </UniModal>
            <UniModal
                icon={faXmarkCircle}
                title={t('user.createdUserError')}
                message=''
                iconColor='#EA2027'
                show={showModalError}
                onHide={() => {
                    setShowModalError(false);
                }}
                isFontAwsome
                iconWidth={100}
                iconHeight={110}
            >
                <div className='modal-body-resume'>
                    <p>{errorMessage}</p>
                    <Button onClick={() => setShowModalError(false)}>Ok</Button>
                </div>
            </UniModal>
        </>
    );
}

export default UniModalUserNew;